module.exports = __webpack_public_path__ + "assets/img/24_418.90be733c.jpg";